import { BrandMark } from './BrandMark'

/**
 * Brand emerald for the "Wise" half of the wordmark — fixed brand identity,
 * same sanctioned-literal-hex rationale as `BrandMark.tsx` (matches that
 * mark's deepest bar, `#12B886`). Never a theme token: the wordmark must
 * read the same regardless of the active accent/theme.
 */
const WISE_EMERALD = '#12B886'

export interface BrandLockupProps {
  /** Mark size in px. Default 32 — sized for the login screen, not the compact nav bar. */
  size?: number
}

/**
 * Mark + "IncentiWise" wordmark ("Wise" in emerald) — the full brand
 * lockup used on the login screen (design doc §5). "Incenti" uses the
 * ordinary text token so it stays legible in both themes; only the fixed
 * brand emerald is a literal hex.
 */
export function BrandLockup({ size = 32 }: BrandLockupProps) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--iw-space-2)' }}>
      {/* Decorative here — the "IncentiWise" wordmark text right beside it is the accessible
          name for the lockup as a whole; a second, redundant "IncentiWise" label on the mark
          itself would double up in the accessible-name computation (e.g. inside a heading). */}
      <BrandMark size={size} title="" />
      <span style={{ fontSize: 'var(--iw-size-2xl)', fontWeight: 'var(--iw-weight-semibold)' as never }}>
        <span style={{ color: 'var(--iw-text)' }}>Incenti</span>
        <span style={{ color: WISE_EMERALD }}>Wise</span>
      </span>
    </div>
  )
}
